import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex flex-column min-vh-100 login-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  href: "/",
  class: "position-absolute btn-primary btn-circle b-close"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
], -1)
const _hoisted_3 = { class: "main_content_iner" }
const _hoisted_4 = { class: "row mx-0" }
const _hoisted_5 = { class: "col-md-8 login-box min-vh-100 d-flex flex-column" }
const _hoisted_6 = { class: "row justify-content-center h-100" }
const _hoisted_7 = { class: "col-md-6 h-100 d-flex flex-column py-5" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold text-center mb-5 mt-4" }, "Create Password", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex text-muted w-100 mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle" })
  ]),
  /*#__PURE__*/_createElementVNode("p", null, " Min. 8 character contains lower case, uppercase, numeric and special characters ")
], -1)
const _hoisted_10 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_11 = { class: "terms-privacy mt-5" }
const _hoisted_12 = { class: "pb-3 mb-5 border-bottom" }
const _hoisted_13 = { class: "d-flex justify-content-between" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Terms of Use")
const _hoisted_15 = {
  key: 0,
  class: "fas fa-check"
}
const _hoisted_16 = {
  key: 1,
  class: "fas fa-check opacity-0"
}
const _hoisted_17 = {
  key: 0,
  class: "text-danger small"
}
const _hoisted_18 = { class: "pb-3 mb-5 border-bottom" }
const _hoisted_19 = { class: "d-flex justify-content-between" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Privacy Policy")
const _hoisted_21 = {
  key: 0,
  class: "fas fa-check"
}
const _hoisted_22 = {
  key: 1,
  class: "fas fa-check opacity-0"
}
const _hoisted_23 = {
  key: 0,
  class: "text-danger small"
}
const _hoisted_24 = { class: "text-center mt-auto" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Save Password ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_login_side_image = _resolveComponent("login-side-image")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_login_side_image),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_Form, {
                onSubmit: _ctx.SavePassword,
                class: "d-flex flex-column h-100"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Field, {
                    name: "password",
                    rules: { required: true, min:8, regex: /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#!$%^&+=]).*$/ },
                    modelValue: _ctx.password,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event))
                  }, {
                    default: _withCtx(({ field, meta }) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["form-group icon-addon mb-4", meta.validated && !meta.valid && !_ctx.submited ? 'has-error border-danger' : ''])
                      }, [
                        _createElementVNode("input", _mergeProps(field, {
                          type: "password",
                          id: "password",
                          placeholder: "Enter Password",
                          class: "form-control material-control",
                          autocomplete: "off"
                        }), null, 16),
                        (!_ctx.submited)
                          ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                              key: 0,
                              class: "text-danger",
                              name: "password"
                            }))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    _: 1
                  }, 8, ["rules", "modelValue"]),
                  _hoisted_9,
                  _createVNode(_component_Field, {
                    name: "password_confirmation",
                    rules: { required: true, regex: /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#!$%^&+=]).*$/, confirmed:_ctx.password },
                    modelValue: _ctx.confirm_password,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.confirm_password) = $event))
                  }, {
                    default: _withCtx(({ field, meta, errors }) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["form-group icon-addon mb-4", meta.validated && !meta.valid && !_ctx.submited ? 'has-error border-danger' : ''])
                      }, [
                        _createElementVNode("input", _mergeProps(field, {
                          type: "password",
                          id: "password_confirmation",
                          placeholder: "Password Again",
                          class: "form-control material-control",
                          autocomplete: "off",
                          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onFormUpdated()))
                        }), null, 16),
                        (errors && errors.length > 0 && !_ctx.submited)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Passwords do not match."))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    _: 1
                  }, 8, ["rules", "modelValue"]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_Field, {
                        rules: {required: true},
                        name: "terms",
                        type: "checkbox",
                        modelValue: _ctx.terms,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.terms) = $event)),
                        value: true
                      }, {
                        default: _withCtx(({ field, meta}) => [
                          _createElementVNode("label", _hoisted_13, [
                            _createVNode(_component_router_link, {
                              to: "/legal/terms-and-conditions",
                              class: "text-primary",
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_14
                              ]),
                              _: 1
                            }),
                            _createElementVNode("span", null, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["btn px-1 py-0 fa-1x", _ctx.terms ? 'btn-primary' : 'btn-outline-primary'])
                              }, [
                                (_ctx.terms)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_15))
                                  : (_openBlock(), _createElementBlock("i", _hoisted_16))
                              ], 2),
                              _createElementVNode("input", _mergeProps({
                                type: "checkbox",
                                name: "terms",
                                class: "btn-check"
                              }, field, {
                                value: true,
                                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onFormUpdated()))
                              }), null, 16)
                            ])
                          ]),
                          (meta.validated && !meta.valid && !_ctx.submited)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_17, " Please accept the Terms and Conditions. "))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_Field, {
                        rules: {required: true},
                        name: "privacy",
                        type: "checkbox",
                        modelValue: _ctx.privacy,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.privacy) = $event)),
                        value: true
                      }, {
                        default: _withCtx(({ field, meta}) => [
                          _createElementVNode("label", _hoisted_19, [
                            _createVNode(_component_router_link, {
                              to: "/legal/privacy-policy",
                              class: "text-primary",
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_20
                              ]),
                              _: 1
                            }),
                            _createElementVNode("span", null, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["btn px-1 py-0 fa-1x", _ctx.privacy ? 'btn-primary' : 'btn-outline-primary'])
                              }, [
                                (_ctx.privacy)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_21))
                                  : (_openBlock(), _createElementBlock("i", _hoisted_22))
                              ], 2),
                              _createElementVNode("input", _mergeProps({
                                type: "checkbox",
                                name: "privacy",
                                class: "btn-check"
                              }, field, {
                                value: true,
                                onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onFormUpdated()))
                              }), null, 16)
                            ])
                          ]),
                          (meta.validated && !meta.valid && !_ctx.submited)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_23, " Please accept the Privacy Policy. "))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("button", {
                      class: "btn btn-primary rounded-5 my-3 px-5 fw-bold",
                      disabled: !_ctx.valid
                    }, [
                      (_ctx.saving)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_27
                          ], 64))
                    ], 8, _hoisted_25)
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit"])
            ])
          ])
        ])
      ])
    ])
  ]))
}